const PROGRAM_SUBTITLES = {
  Preschool:
    "Playful classes where little ones build coordination, confidence, and a love for movement.",
  Recreational:
    "Skill-building classes that stay fun — perfect for kids who want to learn, grow, and flip.",
  Tumbling:
    "Floor skills, power, and progress — from basics to big skills on the tumbling floor.",
  Competitive:
    "Dedicated training for athletes ready to compete and represent Ace Gymnastics.",
};

export function getProgramHeroContent(displayName, pageTitle) {
  const name = displayName || pageTitle || "Program";
  const gymnasticsMatch = pageTitle?.match(/^(.+?)\s+Gymnastics$/i);

  let titleLead = name;
  let titleAccent = null;

  if (gymnasticsMatch) {
    titleLead = gymnasticsMatch[1];
    titleAccent = "Gymnastics";
  } else if (pageTitle && pageTitle !== name) {
    titleLead = pageTitle;
  }

  return {
    eyebrow: "Ace Gymnastics · Programs",
    titleLead,
    titleAccent,
    subtitle: PROGRAM_SUBTITLES[name] || PROGRAM_SUBTITLES[displayName] ||
      "Browse schedules below and register online when spots are open.",
  };
}
